import React from "react";

const ToastSuccessIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'>
    <path
      d='M7 0.875C3.61758 0.875 0.875 3.61758 0.875 7C0.875 10.3824 3.61758 13.125 7 13.125C10.3824 13.125 13.125 10.3824 13.125 7C13.125 3.61758 10.3824 0.875 7 0.875ZM9.64551 4.9998L6.76621 8.99199C6.72597 9.04816 6.67292 9.09393 6.61145 9.1255C6.54999 9.15708 6.48189 9.17354 6.41279 9.17354C6.3437 9.17354 6.27559 9.15708 6.21413 9.1255C6.15267 9.09393 6.09962 9.04816 6.05938 8.99199L4.35449 6.62949C4.30254 6.55703 4.35449 6.45586 4.44336 6.45586H5.08457C5.22402 6.45586 5.35664 6.52285 5.43867 6.6377L6.41211 7.98848L8.56133 5.00801C8.64336 4.89453 8.77461 4.82617 8.91543 4.82617H9.55664C9.64551 4.82617 9.69746 4.92734 9.64551 4.9998Z'
      fill='white'
    />
  </svg>
);

export default ToastSuccessIcon;
